import { computed, unref } from 'vue'

export const GROUP_FILTER_EMPTY_MESSAGE = 'No data for the selected groups in this period'

export function useGroupFilteredData({ data, excluded, extractGroupId, extractGroupName, hasUngrouped }) {
  const groups = computed(() => {
    const rows = unref(data) || []
    const seen = new Set()
    const result = []
    for (const row of rows) {
      const id = extractGroupId(row)
      if (id == null || seen.has(id)) continue
      seen.add(id)
      result.push({ id, name: extractGroupName(row) })
    }
    return result
  })

  const filteredData = computed(() => {
    const rows = unref(data) || []
    const excludedSet = unref(excluded) || new Set()
    if (excludedSet.size === 0) return rows
    const known = groups.value
    // "Show all" only when the selection is truly empty — every named group AND
    // the synthetic "Ugrupperede" option (when present) excluded. Keeping
    // Ugrupperede selected while excluding all named groups is a real filter
    // ("only ungrouped") that can legitimately yield zero rows.
    const allNamedExcluded = known.length > 0 && known.every((g) => excludedSet.has(g.id))
    const ungroupedExcluded = !unref(hasUngrouped) || excludedSet.has(null)
    if (allNamedExcluded && ungroupedExcluded) return rows
    return rows.filter((row) => !excludedSet.has(extractGroupId(row)))
  })

  return { filteredData, groups }
}
